import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "form-row m-3" }
const _hoisted_3 = { class: "form-row m-3" }
const _hoisted_4 = { class: "form-row m-3" }
const _hoisted_5 = { class: "m-3" }
const _hoisted_6 = { class: "row h3 text-success m-3" }
const _hoisted_7 = { class: "row h3 text-danger m-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "row h3 m-4" }, [
      _createElementVNode("span", null, "Change Password")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("label", { class: "form-label" }, "Old Password", -1)),
      _withDirectives(_createElementVNode("input", {
        type: "password",
        class: "form-input",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.oldPassword) = $event)),
        placeholder: "Enter Old Password"
      }, null, 512), [
        [_vModelText, $setup.oldPassword]
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[5] || (_cache[5] = _createElementVNode("label", { class: "form-label" }, "New Password", -1)),
      _withDirectives(_createElementVNode("input", {
        type: "password",
        class: "form-input",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.newPassword) = $event)),
        placeholder: "Enter New Password"
      }, null, 512), [
        [_vModelText, $setup.newPassword]
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[6] || (_cache[6] = _createElementVNode("label", { class: "form-label" }, "Confirm Password", -1)),
      _withDirectives(_createElementVNode("input", {
        type: "password",
        class: "form-input",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.confirmPassword) = $event)),
        placeholder: "Confirm New Password"
      }, null, 512), [
        [_vModelText, $setup.confirmPassword]
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("button", {
        class: "btn btn-primary",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.changePassword && $setup.changePassword(...args)))
      }, "Change Password")
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_6, [...(_cache[7] || (_cache[7] = [
      _createElementVNode("span", null, "Password Changed Successfully", -1)
    ]))], 512), [
      [_vShow, $setup.isPasswordChangeSuccessful == 'true']
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_7, [...(_cache[8] || (_cache[8] = [
      _createElementVNode("span", null, "Password Could not be Changed", -1)
    ]))], 512), [
      [_vShow, $setup.isPasswordChangeSuccessful == 'false']
    ])
  ]))
}